/* eslint-disable no-magic-numbers, class-methods-use-this */
import Phase from '../phase-core/Phase';

const { floor } = Math;

export default class KickRhythm extends Phase {

	_opts = null;

	getBeatLength() {
		return this.length;
	}

	getPreludeLength() {
		return 0.1;
	}

	getPostludeLength() {
		return 0.1;
	}

	constructor(length, opts) {
		super(length);
		this._opts = opts;
	}

	prev_time = -1;

	run({ time, kick_opts }) {
		const { num, div, sequence, dynamics } = this._opts;
		const tn = floor((time.relative + 0.1) * div / num);
		const tp = floor(this.prev_time);
		this.prev_time = tn;
		if (tn !== tp) {
			const dynamic = dynamics[sequence.charAt(tn % sequence.length)];
			if (dynamic) {
				kick_opts.velocity = dynamic.velocity || 1;
				kick_opts.spectrum = dynamic.spectrum || [];
			}
		}
	}

}

